// extracted by mini-css-extract-plugin
export default {"container":"Bi-z","heading":"Ci-z","items":"Di-z","action":"Ei-z","disabled":"Fi-z"};